import { AppTileGridSkeleton, AppTilesGridContainer, AppTileSize } from '@atlassian/mpac-app-tile';
import { breakpointValues, useResponsiveBreakpoint } from '@atlassian/mpac-primitives';
import React from 'react';
import { SectionWrapper } from '../../HomepageCommon.styles';
import { TEST_IDS } from '../../testids';
import { ProminentSectionInfoSkeleton } from '../ProminentSection';
import { RegularSectionSkeleton } from '../RegularSection';
export const SectionsSkeleton = () => {
  const {
    value: breakpoint
  } = useResponsiveBreakpoint();
  const isMobile = breakpoint < breakpointValues.sm;
  const isTablet = breakpoint < breakpointValues.md && breakpoint >= breakpointValues.sm;
  const prominentTileCount = isMobile ? 3 : 5;
  const regularTileCount = isTablet ? 4 : 3;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": TEST_IDS.SECTIONS_SKELETON
  }, /*#__PURE__*/React.createElement(SectionWrapper, null, /*#__PURE__*/React.createElement(AppTilesGridContainer, null, /*#__PURE__*/React.createElement(ProminentSectionInfoSkeleton, null), /*#__PURE__*/React.createElement(AppTileGridSkeleton, {
    tileCount: prominentTileCount
  }))), /*#__PURE__*/React.createElement(SectionWrapper, null, /*#__PURE__*/React.createElement(RegularSectionSkeleton, null, /*#__PURE__*/React.createElement(AppTilesGridContainer, null, /*#__PURE__*/React.createElement(AppTileGridSkeleton, {
    size: AppTileSize.MEDIUM,
    tileCount: regularTileCount
  })))), /*#__PURE__*/React.createElement(SectionWrapper, null, /*#__PURE__*/React.createElement(RegularSectionSkeleton, null, /*#__PURE__*/React.createElement(AppTilesGridContainer, null, /*#__PURE__*/React.createElement(AppTileGridSkeleton, {
    size: AppTileSize.MEDIUM,
    tileCount: regularTileCount
  })))));
};